module.exports = __webpack_public_path__ + "img/cluster_food_security_100px_bluebox.b795c856.png";